<template>
  <span>
    <b v-if="stopped">{{ select }}</b>
    <b v-else>{{ number }}</b>
  </span>
</template>
<script>
export default {
  name: 'SlotNumber',
  props: {
    select: {
      type: [Number, String],
      default: null
    },
    timeout: {
      type: Number,
      default: 10
    },
    start: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stopped: false,
      Interval: null,
      setTimeout: null,
      number: 0
    }
  },
  computed: {

  },
  watch: {
    select() {
      if(this.select !== null) {
        //console.log('select', this.select)
        this.processTimeout()
      }
    }
  },
  methods: {
    spinning() {
      let running = this.start
      clearInterval(this.Interval)
      this.Interval = setInterval(() => {
        running++;
        this.number = running % 10
      }, 100);
    },
    processTimeout() {
      this.setTimeout = setTimeout(()=>{
        this.stopped = true
        clearInterval(this.Interval)
      }, this.timeout)
    }
  },
  mounted() {
    this.spinning()
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}
</script>
